import { render, staticRenderFns } from "./student-transfer.vue?vue&type=template&id=55853ae9"
import script from "./student-transfer.vue?vue&type=script&lang=js"
export * from "./student-transfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports